import { env } from "@/env";

export function getApiBaseUrl(): string {
  return env.VITE_API_BASE_URL.replace(/\/$/, ""); // Remove trailing slash if present
}
